/**
 * Browser Extension Handler
 * Handles errors from browser extensions that may interfere with the app
 */

import { logger } from './logger';

// Known extension error patterns
const EXTENSION_ERROR_PATTERNS = [
  'item cache has not been initialized',
  'default saving location',
  'hide-notification',
  'runtime.lastError',
  'message channel closed'
];

/**
 * Check if an error is from a browser extension
 */
export const isExtensionError = (error: Error | string): boolean => {
  const errorString = typeof error === 'string' ? error : error.message;
  return EXTENSION_ERROR_PATTERNS.some(pattern => 
    errorString.toLowerCase().includes(pattern.toLowerCase())
  );
};

/**
 * Filter console errors from browser extensions
 */
export const initExtensionErrorFilter = (): void => {
  // Store original console methods
  const originalError = console.error;
  const originalWarn = console.warn;
  
  // Override console.error
  // console.error = (...args: unknown[]) => {
  //   const errorString = args.map(arg => String(arg)).join(' ');
  //   if (!isExtensionError(errorString)) {
  //     originalError.apply(console, args);
  //   } else {
  //     logger.log('[ExtensionFilter] Suppressed extension error:', errorString);
  //   }
  // };
  
  // Override console.warn
  // console.warn = (...args: unknown[]) => {
  //   const warnString = args.map(arg => String(arg)).join(' ');
  //   if (!isExtensionError(warnString)) {
  //     originalWarn.apply(console, args);
  //   } else {
  //     logger.log('[ExtensionFilter] Suppressed extension warning:', warnString);
  //   }
  // };
  
  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && isExtensionError(event.reason.toString())) {
      event.preventDefault();
      logger.log('[ExtensionFilter] Suppressed unhandled extension rejection:', event.reason);
    }
  });
  
  // Handle global errors
  window.addEventListener('error', (event) => {
    if (event.message && isExtensionError(event.message)) {
      event.preventDefault();
      logger.log('[ExtensionFilter] Suppressed global extension error:', event.message);
    }
  });
  
  logger.log('[ExtensionFilter] Browser extension error filter initialized');
};

/**
 * Cleanup extension error filter
 */
export const cleanupExtensionErrorFilter = (): void => {
  // This would restore original console methods if needed
  // For now, we'll keep the filter active throughout the app lifecycle
};